module.exports = __webpack_public_path__ + "img/0Q3A7692_FoamcoreMatted.5c08296f.jpg";